import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateMeasures = atom({
  key: 'beacon.measures',
  default: [] as BeaconFilterItem[],
});

export default stateMeasures;
